module.exports = __webpack_public_path__ + "static/media/permission_easier.31a6b86e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/homepage/icons/permission_easier.svg
// module id = 1147
// module chunks = 0